import { ChakraProvider } from "@chakra-ui/react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { APP_NAME } from "config/branding";
import { chakraTheme } from "theme/chakraTheme";

document.title = APP_NAME;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
      <ChakraProvider resetCSS={false} theme={chakraTheme}>
        <App />
      </ChakraProvider>
  </BrowserRouter>
);
